<template>
  <v-container fluid class="py-6">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <!-- Header -->
        <v-card class="mb-6" elevation="2">
          <v-card-title class="primary white--text">
            <v-icon color="white" class="mr-2">mdi-account-check-outline</v-icon>
            Análise de Avaliação - Responsáveis
          </v-card-title>
          <v-card-text v-if="instituicao" class="pa-4 pb-2">
            <span class="body-1 font-weight-medium">{{ instituicao }}</span>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text color="primary" :loading="loading" @click="carregar">
              <v-icon left>mdi-refresh</v-icon>
              Atualizar
            </v-btn>
          </v-card-actions>
        </v-card>

        <!-- Erro (ex: CPF não autorizado) -->
        <v-alert v-if="erro" type="error" dense outlined class="mb-6">
          {{ erro }}
        </v-alert>

        <template v-else>
          <!-- Resumo -->
          <v-row class="mb-2">
            <v-col cols="6" md="3">
              <v-card elevation="2" class="pa-4 text-center resumo-card">
                <div class="text-h5 font-weight-bold primary--text">{{ totalCredenciados }}</div>
                <div class="text--secondary body-2">Credenciados</div>
              </v-card>
            </v-col>
            <v-col cols="6" md="3">
              <v-card elevation="2" class="pa-4 text-center resumo-card">
                <div class="text-h5 font-weight-bold success--text">{{ totalAvaliaram }}</div>
                <div class="text--secondary body-2">Avaliaram</div>
              </v-card>
            </v-col>
            <v-col cols="6" md="3">
              <v-card elevation="2" class="pa-4 text-center resumo-card">
                <div class="text-h5 font-weight-bold error--text">{{ totalNaoAvaliaram }}</div>
                <div class="text--secondary body-2">Não avaliaram</div>
              </v-card>
            </v-col>
            <v-col cols="6" md="3">
              <v-card elevation="2" class="pa-4 text-center resumo-card">
                <div class="text-h5 font-weight-bold" :class="`${corPercentual}--text`">{{ percentualAvaliado.toFixed(1) }}%</div>
                <div class="text--secondary body-2">Percentual avaliado</div>
              </v-card>
            </v-col>
          </v-row>

          <v-text-field
            v-model="busca"
            label="Buscar por nome ou CPF"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            clearable
            hide-details
            class="mb-6"
          ></v-text-field>

          <!-- Listas -->
          <v-row>
            <v-col cols="12" md="6">
              <v-card elevation="2">
                <v-card-title class="success white--text py-2">
                  <v-icon color="white" class="mr-2">mdi-check-circle-outline</v-icon>
                  Já avaliaram ({{ avaliaramFiltrado.length }})
                </v-card-title>
                <v-list dense class="lista-avaliadores">
                  <v-list-item v-for="item in avaliaramFiltrado" :key="item.chave_avaliador">
                    <v-list-item-icon>
                      <v-icon color="success" small>mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.nome_responsavel.trim() }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.cpf_responsavel | filterCpf }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!loading && !avaliaramFiltrado.length">
                    <v-list-item-content class="text-center text--secondary py-4"> Nenhum registro encontrado. </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card elevation="2">
                <v-card-title class="grey darken-1 white--text py-2">
                  <v-icon color="white" class="mr-2">mdi-circle-outline</v-icon>
                  Não avaliaram ({{ naoAvaliaramFiltrado.length }})
                  <v-spacer />
                  <v-btn text small color="white" :disabled="!naoAvaliaramFiltrado.length" @click="exportarPdfNaoAvaliaram">
                    <v-icon left small>mdi-file-pdf-box</v-icon>
                    PDF
                  </v-btn>
                </v-card-title>
                <v-list dense class="lista-avaliadores">
                  <v-list-item v-for="item in naoAvaliaramFiltrado" :key="item.chave_avaliador">
                    <v-list-item-icon>
                      <v-icon color="grey" small>mdi-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.nome_responsavel.trim() }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.cpf_responsavel | filterCpf }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!loading && !naoAvaliaramFiltrado.length">
                    <v-list-item-content class="text-center text--secondary py-4"> Nenhum registro encontrado. </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>

        <v-card v-if="loading" class="text-center pa-8 mt-4" elevation="1">
          <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import filtros from "@/libs/filters";
import AvaliacaoInstitucionalServices from "@/services/avaliacaoInstitucional/AvaliacaoInstitucionalServices";

export default {
  name: "AnaliseAvaliacaoResponsavel",
  data: () => ({
    lista: [],
    busca: "",
    loading: false,
    erro: "",
  }),
  components: {},
  filters: filtros,
  computed: {
    instituicao() {
      return this.lista[0]?.instituicao || "";
    },
    totalCredenciados() {
      return this.lista.length;
    },
    avaliaram() {
      return this.lista.filter((i) => Number(i.ja_avaliou) === 1);
    },
    naoAvaliaram() {
      return this.lista.filter((i) => Number(i.ja_avaliou) !== 1);
    },
    totalAvaliaram() {
      return this.avaliaram.length;
    },
    totalNaoAvaliaram() {
      return this.naoAvaliaram.length;
    },
    percentualAvaliado() {
      if (!this.totalCredenciados) return 0;
      return (this.totalAvaliaram / this.totalCredenciados) * 100;
    },
    corPercentual() {
      if (this.percentualAvaliado >= 75) return "success";
      if (this.percentualAvaliado >= 40) return "warning";
      return "error";
    },
    avaliaramFiltrado() {
      return this.filtrar(this.avaliaram);
    },
    naoAvaliaramFiltrado() {
      return this.filtrar(this.naoAvaliaram);
    },
  },
  methods: {
    filtrar(lista) {
      let l = [...lista].sort((a, b) => a.nome_responsavel.trim().localeCompare(b.nome_responsavel.trim()));
      if (this.busca) {
        const termo = this.busca.toLowerCase();
        l = l.filter(
          (i) => i.nome_responsavel.toLowerCase().includes(termo) || (i.cpf_responsavel || "").includes(termo)
        );
      }
      return l;
    },
    async carregar() {
      this.loading = true;
      this.erro = "";
      try {
        const resp = await AvaliacaoInstitucionalServices.analiseAvaliacaoResponsavel();
        if (Array.isArray(resp)) {
          this.lista = resp;
        } else if (resp && resp.error) {
          this.erro = resp.error;
          this.lista = [];
        } else {
          this.lista = [];
        }
      } catch (e) {
        this.erro = e?.response?.data?.error || e?.response?.data?.message || "Não foi possível carregar a análise. Verifique se o seu CPF está credenciado.";
        this.lista = [];
      } finally {
        this.loading = false;
      }
    },
    exportarPdfNaoAvaliaram() {
      const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
      const dataAtual = new Date().toLocaleString("pt-BR");

      doc.setFontSize(14);
      doc.text("Responsáveis que não avaliaram", 40, 40);
      doc.setFontSize(10);
      doc.text(this.instituicao, 40, 58);
      doc.text(`Emitido em ${dataAtual}`, 40, 74);

      doc.setFontSize(11);
      doc.text(`Total não avaliaram: ${this.naoAvaliaramFiltrado.length} de ${this.totalCredenciados} credenciados`, 40, 92);

      doc.autoTable({
        startY: 108,
        head: [["Nome", "CPF"]],
        body: this.naoAvaliaramFiltrado.map((i) => [i.nome_responsavel.trim(), filtros.filterCpf(i.cpf_responsavel)]),
        styles: { fontSize: 9 },
        headStyles: { fillColor: [97, 97, 97] },
        margin: { left: 40, right: 40 },
      });

      doc.save(`nao-avaliaram-${Date.now()}.pdf`);
    },
  },
  mounted: function () {
    this.carregar();
  },
};
</script>

<style scoped>
.resumo-card {
  border-radius: 12px !important;
}

.lista-avaliadores {
  max-height: 480px;
  overflow-y: auto;
}
</style>
